export enum FroalaEditorType {
    All = 0,
    Venue = 1,
    Rsvp = 2,
    PublicPage = 3,
    ConfirmationMail = 4,
    Document = 5,
    AdHoc = 6,
    ThankYou = 7
}
